import { render, staticRenderFns } from "./StatusChange.vue?vue&type=template&id=19a019be&scoped=true&"
import script from "./StatusChange.vue?vue&type=script&lang=js&"
export * from "./StatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a019be",
  null
  
)

export default component.exports